import { NgModule } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  TeamOutline,
  FolderOpenOutline,
  FolderOutline,
  DatabaseOutline,
  TableOutline,
  CaretDownOutline,
  CloseOutline,
  CloseCircleOutline,
  CodeOutline,
  CopyOutline,
  DeleteOutline,
  DeleteColumnOutline,
  DownOutline,
  DragOutline,
  EditOutline,
  FunnelPlotOutline,
  HolderOutline,
  InfoOutline,
  LineChartOutline,
  LogoutOutline,
  MinusOutline,
  MinusCircleOutline,
  PlayCircleOutline,
  PlusOutline,
  PlusCircleOutline,
  SaveOutline,
  SearchOutline,
  SettingOutline,
  WarningOutline,
  BulbOutline,
  MoonOutline,
  CheckOutline,
  SyncOutline,
  BgColorsOutline,
  DownloadOutline,
  CheckCircleOutline,
  QuestionCircleOutline,
  LoadingOutline,
  AppstoreOutline,
  UserOutline,
  UpOutline,
  AreaChartOutline,
  BarChartOutline,
  DotChartOutline,
  PieChartOutline,
  FundOutline,
  Loading3QuartersOutline,
  RadarChartOutline,
  ThunderboltOutline,
  ArrowRightOutline,
  ReloadOutline,
  LeftOutline,
  RightOutline,
} from '@ant-design/icons-angular/icons';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  TeamOutline,
  FolderOpenOutline,
  FolderOutline,
  DatabaseOutline,
  TableOutline,
  CaretDownOutline,
  CloseOutline,
  CloseCircleOutline,
  CodeOutline,
  CopyOutline,
  DeleteOutline,
  DeleteColumnOutline,
  DownOutline,
  DragOutline,
  EditOutline,
  FunnelPlotOutline,
  HolderOutline,
  InfoOutline,
  LineChartOutline,
  LogoutOutline,
  MinusOutline,
  MinusCircleOutline,
  PlayCircleOutline,
  PlusOutline,
  PlusCircleOutline,
  SaveOutline,
  SearchOutline,
  SettingOutline,
  WarningOutline,
  BulbOutline,
  MoonOutline,
  CheckOutline,
  SyncOutline,
  BgColorsOutline,
  DownloadOutline,
  CheckCircleOutline,
  QuestionCircleOutline,
  LoadingOutline,
  AppstoreOutline,
  UserOutline,
  UpOutline,
  AreaChartOutline,
  BarChartOutline,
  DotChartOutline,
  PieChartOutline,
  FundOutline,
  Loading3QuartersOutline,
  RadarChartOutline,
  ThunderboltOutline,
  ArrowRightOutline,
  ReloadOutline,
  LeftOutline,
  RightOutline,
];

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class IconsProviderModule {}
